import { ButtonBack } from "@/components/buttons/ButtonBack"
import { ButtonNext } from "@/components/buttons/ButtonNext"
import { LoadingButton } from "@/components/ui/button"

import type { CustomerApplications } from "@boundless/bl-api-client/customer/models"

type SummaryNavigationProps = {
  application: CustomerApplications
  isLoading?: boolean
  needsDebtReview?: boolean
  handleSubmit?: () => void
  handleBack: () => void
}

export function SummaryNavigation({
  application,
  handleSubmit,
  handleBack,
  isLoading,
  needsDebtReview,
}: SummaryNavigationProps) {
  return (
    <div className="mt-8 flex w-full flex-col gap-2 sm:flex-row sm:justify-end">
      <ButtonBack type="button" variant="outline" onClick={handleBack}>
        Back
      </ButtonBack>
      {isLoading ? (
        <LoadingButton className="min-w-35">Submit</LoadingButton>
      ) : (
        handleSubmit &&
        !application.isSubmitted && (
          <ButtonNext
            disabled={
              !application.isReadyToReview ||
              !application.fundingNeeds.isSigned ||
              needsDebtReview
            }
            onClick={handleSubmit}
          >
            Submit
          </ButtonNext>
        )
      )}
    </div>
  )
}
